module.exports = __webpack_public_path__ + "static/media/sologo.98e83f15.png";